import { useErrorInputs } from '../../../hooks/useErrorInputs';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useForm } from '../../../hooks/useForm';
import FormHelperText from '@mui/material/FormHelperText';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';

import identificationTypes from "../../../data/identificationTypes.json";
import { ActionButtons } from '../../others/ActionButtons';
import { insertDataClient } from "../../../services/client.service";
import { fetchClientByNit } from '../../../services/client.service';
import { calculateDV } from '../../../utils/invoice';

import '../../../styles/components/_forms.scss';
import { useTranslation } from 'react-i18next';

export const CreateClient = ({ data, open, onClose }) => {
    const { t } = useTranslation();
    const modelClient = {
        type_identification: '',
        identification: '',
        identification_digit: '',
        business_name: '',
        id_company: ''
    }
    const [dto, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(modelClient);
    const [errorInputs, handleErrorInput, resetErrors, validForm] = useErrorInputs({});
    const [{ userSession }] = useDataAuth();

    const fieldsRequired = ['type_identification', 'identification', 'business_name'];

    const handleSubmit = async () => {
        dto.id_company = data.id_company
        const isValid = validForm(fieldsRequired, dto);
        if (!isValid) {
            return;
        } else {
            const response = await insertDataClient(JSON.stringify(dto), userSession.token);
            handleClose(response.data[0].id);
        }
    };

    const handleClose = (id_client) => {
        setAllInfo(modelClient);
        resetErrors();
        onClose({ id_client });
    };

    const calculate = () => {
        if (isValidIdentification()) {
            const dv = calculateDV(dto.identification);
            handleDirectInputChange("identification_digit", dv);
        } else
            handleDirectInputChange("identification_digit", "");
    }

    const handleClient = async ({ target }) => {
        const identification = target.value;
        handleDirectInputChange("identification", identification);
        if (identification.length > 7) {
            setTimeout(async () => {
                const response = await fetchClientByNit(userSession.token, identification);
                if (response.data) {
                    handleDirectInputChange("identification", "");
                    handleDirectInputChange("identification_digit", "");
                    handleErrorInput("identification", { isError: true, messageError: t("client.alreadyExists") });
                } else {
                    handleErrorInput("identification", { isError: false, messageError: '' });
                }
            }, 1000);
        }
    };

    const isValidIdentification = () => dto.identification.length > 5 && dto.type_identification === '31';

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
                {t("company.companyInfo")}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{ marginTop: "1%" }}>
                    <Grid size={{ xs: 10 }}>
                        <FormControl fullWidth required size="small"
                            error={Boolean(errorInputs.type_identification?.isError)}
                        >
                            <InputLabel>Tipo de Identificación</InputLabel>
                            <Select name="type_identification" label="Tipo de Identificación"
                                value={dto.type_identification}
                                onChange={handleInputChange}
                                onBlur={calculate}
                            >
                                {identificationTypes.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errorInputs.type_identification?.isError && (
                                <FormHelperText>{errorInputs.type_identification.messageError}</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 2 }}>
                        <TextField fullWidth disabled name='identification_digit' label="DV" size="small"
                            value={dto.identification_digit}
                        />
                    </Grid>

                    <Grid size={{ xs: 6}}>
                        <TextField fullWidth required name='identification' label="Identificación" size="small" type="number" className='input-no-spinner'
                            value={dto.identification}
                            error={Boolean(errorInputs.identification?.isError)}
                            helperText={errorInputs.identification?.messageError || ''}
                            onChange={handleClient}
                            onBlur={calculate}
                        />
                    </Grid>

                    <Grid size={{ xs: 6}}>
                        <TextField
                            fullWidth
                            required
                            name='business_name'
                            label="Razón Social (Nombre Usuario)"
                            size="small"
                            value={dto.business_name}
                            error={Boolean(errorInputs.business_name?.isError)}
                            helperText={errorInputs.business_name?.messageError || ''}
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <ActionButtons
                    onCancel={onClose}
                    onSubmit={handleSubmit}
                />
            </DialogActions>
        </Dialog>
    );
};
